export const humanizeTusCategory = (tusCategory: string) => {
  const lastSegment = tusCategory.split('/').pop() ?? tusCategory;
  return `${lastSegment.charAt(0).toUpperCase()}${lastSegment.slice(1)}`;
};
